const alphabets = {
    'A': 'A.png',
    'B': 'B.png',
    'C': 'C.png',
    'D': 'D.png',
    'E': 'E.png',
    'F': 'F.png',
    'G': 'G.png',
    'H': 'H.png',
    'I': 'I.png',
    'J': 'J.png',
    'K': 'K.png',
    'L': 'L.png',
    'M': 'M.png',
    'N': 'N.png',
    'O': 'O.png',
    'P': 'P.png',
    'Q': 'Q.png',
    'R': 'R.png',
    'S': 'S.png',
    'T': 'T.png',
    'U': 'U.png',
    'V': 'V.png',
    'W': 'W.png',
    'X': 'X.png',
    'Y': 'Y.png',
    'Z': 'Z.png',
    'TSI': 'TSI.png',
    'TSA': 'TSA.png',
    'TSO': 'TSO.png',
    'TSU': 'TSU.png',
    'VRI': 'VRI.png',
    'VRA': 'VRA.png',
    'VRO': 'VRO.png',
    'VRU': 'VRU.png',
    'DR': 'DR.png',
    'DT': 'DT.png',
    'DV': 'DV.png',
    'DJ': 'DJ.png',
    'DN': 'DN.png',
    'DM': 'DM.png',
    'QUE': 'QUE.png',
    'QUA': 'QUA.png',
    'QUI': 'QUI.png',
    'FA': 'FA.png',
    'FLI': 'FLI.png',
    'FOL': 'FOL.png',
    'FU': 'FU.png',
    'PAL': 'PAL.png',
    'PUL': 'PUL.png',
    'POL': 'POL.png',
    'PEL': 'PEL.png',
    'PIL': 'PIL.png',
    'HA': 'HA.png',
    'HO': 'HO.png',
    'HU': 'HU.png',
    'HI': 'HI.png',
    'HE': 'HE.png',
    'ON': 'ON.png',
    'AN': 'AN.png',
    'IN': 'IN.png',
    'UN': 'UN.png',
    'YN': 'YN.png',
    'EN': 'EN.png',
    'BLE': 'BLE.png',
    'BLA': 'BLA.png',
    'BLI': 'BLI.png',
    'BLO': 'BLO.png',
    'LA': 'LA.png',
    'LI': 'LI.png',
    'LU': 'LU.png',
    'LE': 'LE.png',
    'LO': 'LO.png',
    'VE': 'VE.png',
    'VA': 'VA.png',
    'VO': 'VO.png',
    'VU': 'VU.png',
    'NOY': 'NOY.png',
    'NA': 'NA.png',
    'NEY': 'NEY.png',
    'AC': 'AC.png',
    'UC': 'UC.png',
    'IC': 'IC.png',
    'OC': 'OC.png',
    'YC': 'YC.png',
    'KI': 'KI.png',
    'KAN': 'KAN.png',
    'POI': 'POI.png',
    'PAI': 'PAI.png',
    'PUI': 'PUI.png',
    'XA': 'XA.png',
    'XE': 'XE.png',
    'ZE': 'ZE.png',
    'ZIN': 'ZIN.png',
    'ZON': 'ZON.png',
    'ZAN': 'ZAN.png',
    'OS': 'OS.png',
    'AS': 'AS.png',
    'IS': 'IS.png',
    'ES': 'ES.png',
    'US': 'US.png',
    'OI': 'OI.png',
    'OO': 'OO.png',
    'EY': 'EY.png',
    'EE': 'EE.png',
    'EA': 'EA.png',
    'EU': 'EU.png',
    'EI': 'EI.png',
    'EO': 'EO.png',
    'AU': 'AU.png',
    'NM': 'NM.png',
    'NP': 'NP.png',
    'NT': 'NT.png',
    'NC': 'NC.png',
    'NG': 'NG.png',
    'NJ': 'NJ.png',
    'NN': 'NN.png',
    'ND': 'ND.png',
    'NH': 'NH.png'
};

const nombres = {
    '0': '0.png',
    '1': '1.png',
    '2': '2.png',
    '3': '3.png',
    '4': '4.png',
    '5': '5.png',
    '6': '6.png',
    '7': '7.png',
    '8': '8.png',
    '9': '9.png'
};

export { alphabets, nombres };